import React, {Component, Fragment} from 'react';
import image from "../../assets/img/nophoto.png";
import connect from "react-redux/es/connect/connect";
import {
    agentListing,
    appendChatMessage, appendLastChatMessage, appendReceiveChatMessage,
    changeGroupName,
    createGroup, DeleteGroup, exitFromGroup, getChatList,
    getGroupConversation, removeDataInRedux, setDataInRedux, setOnlineInRedux,
    UpdateGroup
} from "../../actions/profile";
import MessageItem from "../common/MessageItem";
import DefaultChat from "../common/defaultChat";
import DataNotFound from "../common/DataNotFound";
import Select from 'react-select';
import {
    Badge,
    ButtonDropdown,
    DropdownToggle,
    DropdownItem,
    DropdownMenu
} from "reactstrap";
import {Form, FormGroup, Input, Label} from "reactstrap";
import {components} from "react-select";
import moment from "moment";
import defaultAvatar from '../../assets/img/nophoto.png'
import notFoundImg from '../../assets/img/undraw_No_data_re_kwbl.svg'
import {actionGetAllPropertyList} from "../../actions/propertysAction";
import SendPropertyChatCard from "../chat/sendPropertyChatCard";
import ReactCrop from "react-image-crop";
import {actionAddUpdateUserProfilePic} from "../../actions/auth";
import ReactTooltip from "react-tooltip";
import swal from 'sweetalert';
import Logo from "../../assets/img/Logo/1.png";
import {Link} from "react-router-dom";

class SingleAgentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            group: '',
            isOpen: false,
            is_typing: false,
            LoggedInUsesIsOwner: false,
            modal_name: '',
            optionSelected: null,
            admin: null,
            filterChatMsg: '',
            properties: [],
            selectedAgent: '',
            chatFilterMember: '',
            GroupAdmin: '',
            GroupAdminEmail: '',
            GroupOwner: '',
            crop: {
                unit: '%',
                width: 30,
                aspect: 1,
            },
            src: '',
            filter: '',
            chatFilter: '',
            errors: {},
            limit: 20,
            offset: 0,
            totalConversationPages: 0
        }
    }

    decreasePageCount = () => this.state.totalConversationPages > 0 && this.setState({totalConversationPages: (this.state.totalConversationPages - 1)});

    componentDidMount() {
        if (this.props.reduxData._id) {
            this.props.getGroupConversation(
                this.props.user._id,
                this.props.reduxData._id ? this.props.reduxData._id : 0,
                0,
                this.state.limit,
                0,
                this.scrollToBottom, this.decreasePageCount);
        }


        // Event Receiver
        const {socket, chatLists, chatListsLoader} = this.props;
        socket.on('sendMessage', message => {
            console.log({message}, '-----------------Event Receiver');

            const ID = (this.props.reduxData || this.state.selectedAgent) && this.props.reduxData._id ? this.props.reduxData._id : this.state.selectedAgent._id;

            // message.receiver_token === this.state.chat_token && this.props.appendChatMessage(message, ID);
            console.log(message, " Reciv ====> message -<<<");
            this.props.appendReceiveChatMessage(message);
            this.scrollToBottom();


            // if(chatLists && chatLists[0] && chatLists[0].conversation){
            //     this.props.appendReceiveChatMessage(message);
            //     this.scrollToBottom();
            // }else {
            //     this.props.appendLastChatMessage(message)
            // }

        });

        socket.on('setUserTyping', message => {
            console.log({message});
            (this.state.selectedAgent._id === message._id &&
                this.setState({is_typing: message.is_typing}))
        });

        socket.on('setUserOnline', message => {
            console.log({message}, '<-------------------online');

            this.setState({
                selectedAgent: {
                    ...this.state.selectedAgent,
                    is_online: message.is_online,
                }
            }, () => {
                this.props.setOnlineInRedux(message);
                this.scrollToBottom()
            });
        });

        // CHAT OFFSET PAGINATION

    }


    componentDidUpdate(prevProps, nextState) {
        prevProps.totalConversation !== this.props.totalConversation && this.setState({totalConversationPages: (this.props.totalConversation * 10) / 100});

        const ID = (this.props.reduxData || this.state.selectedAgent) && this.state.selectedAgent.type === "Agent" ? this.props.reduxData._id || this.state.selectedAgent._id : 0;
        const groupID = (this.state.selectedAgent && this.state.selectedAgent.type === "Group") ? this.state.selectedAgent._id : 0;
        const chatPanel = document.getElementById("chat-msg-container");
        // console.log(chatPanel,"chatPanel");
        chatPanel && chatPanel.addEventListener("scroll", () => {

            const {groupConversationListingLoader, chatLists, totalConversation, isNextAPICall} = this.props;
            let scrollHeight = chatPanel.scrollHeight;
            let scrollTop = chatPanel.scrollTop;
            let clientHeight = chatPanel.clientHeight;

            if ((scrollTop + clientHeight) > (scrollHeight - 650)) {
                // this.setState({offset:this.state.offset+1},()=>{
                //     console.log("call Pagination API");
                //     this.props.getGroupConversation(
                //         this.props.user._id,
                //         0,
                //         ID ? ID: 0,
                //         this.state.limit,
                //         this.state.offset,
                //     )
                // });

            } else {
                if (!groupConversationListingLoader && chatLists && chatLists.length !== parseInt(totalConversation) && isNextAPICall) {
                    this.setState({offset: this.state.offset + 1}, () => {

                        this.props.getGroupConversation(
                            this.props.user._id,
                            ID,
                            groupID,
                            this.state.limit,
                            this.state.offset,
                        )
                    });

                }

            }
            // console.log(window.scrollY,"window.scrollY");
        });

    }

    onSendMessageSubmit = (e) => {
        e.preventDefault();
        if (this.state.message.trim()) {
            const {socket} = this.props;
            const {chat_token} = this.state;
            const receiverToken = `${this.props.user._id}~${this.state.selectedAgent.type}`;
            const config = this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id ? {
                chat_token,
                receiver_token: chat_token,
                user: this.props.user._id,
                message: this.state.message.trim(),
                receiver: this.state.selectedAgent.type === "Group" && this.state.selectedAgent.members.map(member => [{user: member._id}]),
                group: this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id
            } : {
                chat_token,
                receiver_token: receiverToken,
                user: this.props.user._id,
                message: this.state.message.trim(),
                receiver: [{user: this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id || this.props.reduxData._id}]
            };
            // Send Message Event
            socket.emit('sendMessage', config, (responseData) => {
                console.log('Callback called with data:', JSON.stringify(responseData));
                const ID = (this.props.reduxData || this.state.selectedAgent) && this.props.reduxData._id ? this.props.reduxData._id : this.state.selectedAgent._id;
                if (parseInt(responseData.status) === parseInt(200)) {
                    console.log(responseData, "responseData<--------");
                    this.props.appendChatMessage(responseData.data);
                    this.scrollToBottom();
                    // if (responseData.data.chat_token === this.state.chat_token) {
                    //     this.props.appendChatMessage(responseData.data);
                    //     this.scrollToBottom();
                    // }
                }


            });
            this.setState({message: " "})

        }
    };

    handleKeyUp = e => {
        if (this.state.message.length < 1) {
            //this.setState({is_typing:false});
            const {socket} = this.props;
            const req = {
                userId: this.props.user._id,
                receiverUserId: this.props.reduxData._id || this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id
            };
            //console.log(req);
            socket.emit('setUserTypingStop', req, (responseData) => {
                console.log('Callback called with data:', JSON.stringify(responseData));
            });
            console.log('false')
        }
    };

    handleChange = (e) => {
        e.preventDefault();

        this.setState({[e.target.name]: e.target.value});
        const count = 3000;

        if ([e.target.name === "message"]) {
            // this.setState({is_typing:this.state.message.length && false});
            const {socket} = this.props;
            const req = {
                userId: this.props.user._id,
                receiverUserId: this.props.reduxData._id || this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id
            };
            //console.log(req);
            socket.emit('setUserTyping', req, (responseData) => {
                console.log('Callback called with data:', JSON.stringify(responseData));
            });

            setTimeout(() => socket.emit('setUserTypingStop', {
                userId: this.props.user._id,
                receiverUserId: this.props.reduxData._id || this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id
            }), count);
        }
    };

    scrollToBottom = () => {
        const myDiv = document.getElementById("chat-msg-container");
        if (myDiv) {
            myDiv.scrollTop = myDiv.scrollHeight;
        }

    };

    setChatAgent = (agent) => {
        let new_group_members = [];
        agent.type === "Group" && agent.members.map((m, i) => {

            if (m._id !== this.props.user._id) {
                /* this.props.chatLists && this.props.chatLists.map(c => (c._id === m._id) &&*/
                new_group_members.push({value: m._id, label: m.name})
                /* );*/

            }
        });
        let admins = [];
        let LoggedInIaAdmin = [];
        agent.type === "Group" && agent.admins.map((m, i) => {

            if (m._id !== this.props.user._id) {
                /* this.props.chatLists && this.props.chatLists.map(c => (c._id === m._id) &&*/
                admins.push({value: m._id, label: m.name})
                /* );*/

            }
            if (m._id === this.props.user._id) {
                /* this.props.chatLists && this.props.chatLists.map(c => (c._id === m._id) &&*/
                LoggedInIaAdmin.push({value: m._id, label: m.name})
                /* );*/

            }
        });
        let GroupOwner = agent.type === "Group" && {value: agent.group_owner._id, label: agent.group_owner.name};
        const isGroupAdmin = agent.type === "Group" && agent.members && agent.members.filter(a => a._id === agent.group_owner._id);
        const LoggedInUser = this.props.user && this.props.user._id;
        const UserIsOwner = isGroupAdmin && isGroupAdmin.filter(a => a._id === LoggedInUser);
        //console.log({isGroupAdmin});
        //console.log({LoggedInUser});
        //console.log({UserIsOwner});
        this.setState({
                message: '',
                selectedAgent: agent,
                GroupAdmin: agent.type === "Group" ? agent.group_owner.name : '',
                GroupAdminEmail: agent.type === "Group" ? agent.group_owner.email : '',
                GroupOwner: agent.type === "Group" ? GroupOwner : '',
                admins,
                LoggedInIaAdmin,
                modal_name: "CREATE_GROUP",
                group: agent.type === "Group" && agent.name,
                avatar_preview: agent.type === "Group" && agent.image,
                optionSelected: new_group_members,
                chat_token: `${agent._id}~${agent.type}`,
                LoggedInUsesIsOwner: UserIsOwner.length > 0,
                offset: 0
            }, () =>
                this.props.getGroupConversation(
                    this.props.user._id,
                    (agent.type === "Agent" && agent._id) ? agent._id : 0,
                    (agent.type === "Group" && agent._id) ? agent._id : 0,
                    this.state.limit,
                    0,
                    this.state.totalConversationPages,
                    this.scrollToBottom, this.decreasePageCount, true),
            this.props.removeDataInRedux()
        );

    };

    handleMultiChange = (option) => {
        this.setState({optionSelected: option});
    };

    handleValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        if (fields.group.length === 0) {
            formIsValid = false;
            errors.group = "Group Name must be Required!";
        }
        if (fields.optionSelected.length === 0) {
            formIsValid = false;
            errors.optionSelected = "Group Member must be Required!";
        }
        if (fields.GroupOwner.length === 0) {
            formIsValid = false;
            errors.GroupOwner = "Group Owner must be Required!";
        }
        this.setState({errors: errors});
        return formIsValid;
    };

    onCreateGroupSubmit = (e) => {
        e.preventDefault();
        if (this.handleValidation()) {
            const members = this.state.optionSelected && this.state.optionSelected.map(m => m.value).concat(this.props.user._id);
            const NewMember = members.filter(f => f !== this.state.GroupOwner.value);
            const admins = this.state.admins && this.state.admins.map(m => m.value);
            const LoggedInIaAdmin = this.state.LoggedInIaAdmin && this.state.LoggedInIaAdmin.map(l => l.value);
            const req = {
                name: this.state.group,
                user: this.props.user._id,
                image: this.state.avatar,
                group_owner: this.state.GroupOwner.value,
                status: this.state.selectedAgent.status ? this.state.selectedAgent.status : 1,
                members: NewMember.concat(this.state.GroupOwner.value),
                admins:admins.concat(LoggedInIaAdmin),
            };
            console.log({req});
            this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id ? this.props.UpdateGroup(this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id, req) : this.props.createGroup(req);
            this.props.getChatList(this.props.user._id, () => this.props.getGroupConversation(
                this.props.user._id,
                (this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id) ? this.state.selectedAgent._id : 0,
                (this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id) ? this.state.selectedAgent._id : 0,
                this.state.limit,
                0,
                this.scrollToBottom));
            this.props.changeGroupName({
                _id: this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id,
                name: this.state.group,
                image: this.state.avatar_preview,
            });
            this.props.setDataInRedux({
                _id: this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id,
                name: this.state.group,
                image: this.state.avatar_preview,
            });
            document.getElementById('closeBtn').click()
        }
    };

    onInactiveGroup = () => {
        const members = this.state.optionSelected && this.state.optionSelected.map(m => m.value).concat(this.props.user._id);
        const NewMember = members.filter(f => f !== this.state.GroupOwner.value);
        const admins = this.state.admins && this.state.admins.map(m => m.value);
        const req = {
            name: this.state.group,
            user: this.props.user._id,
            image: this.state.avatar,
            status: 0,
            group_owner: this.state.GroupOwner.value,
            members: NewMember.concat(this.state.GroupOwner.value),
            admins
        };
        this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id ? this.props.UpdateGroup(this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id, req) : this.props.createGroup(req);
        this.props.getChatList(this.props.user._id, () => this.props.getGroupConversation(
            this.props.user._id,
            (this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id) ? this.state.selectedAgent._id : 0,
            (this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id) ? this.state.selectedAgent._id : 0,
            this.state.limit,
            0,
            this.scrollToBottom), this.setState({selectedAgent: ''}));
        this.props.changeGroupName({
            _id: this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id,
            name: this.state.group,
            image: this.state.avatar_preview,
        });
        this.props.setDataInRedux({
            _id: this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id,
            name: this.state.group,
            image: this.state.avatar_preview,
        });
    };

    handleModal = name => {
        this.setState({modal_name: name});
        const request = {
            q: "",
            location: "",
            offset: 0,
            limit: "",
            category: '',
            user: this.props.user._id,
            // type: "PRIVATE",
            type: "",
            status: "",
            bedRooms: "",
            bathRooms: "",
            furnishedStatus: "",
            transactionType: "",
            minPrice: "",
            maxPrice: "",
            searchError: '',
        };
        this.props.actionGetAllPropertyList(request);
    };

    handleChangeCheckbox = (selected) => {
        this.setState({
            admins: selected
        });
    };

    handleChangeCheckboxGroupOwner = (selected) => {
        this.setState({
            GroupOwner: selected
        })
    };

    handleSendProperty = (data) => {
        const {socket} = this.props;
        const {chat_token} = this.state;
        const receiverToken = `${this.props.user._id}~${this.state.selectedAgent.type}`;
        const config = this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id ? {
            chat_token,
            receiver_token: chat_token,
            user: this.props.user._id,
            receiver: this.state.selectedAgent.type === "Group" && this.state.selectedAgent.members.map(member => [{user: member._id}]),
            group: this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id,
            properties: data._id,
        } : {
            chat_token,
            receiver_token: receiverToken,
            user: this.props.user._id,
            receiver: [{user: this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id}],
            properties: data._id,
        };


        this.setState({
            properties: [...this.state.properties, data._id],
        });
        socket.emit('sendMessage', config, (responseData) => {
            console.log('Callback called with data:', JSON.stringify(responseData));
            if (parseInt(responseData.status) === parseInt(200)) {
                this.props.appendChatMessage(responseData.data);
                this.scrollToBottom();
                // const ID = (this.props.reduxData || this.state.selectedAgent) && this.props.reduxData._id ? this.props.reduxData._id : this.state.selectedAgent._id;
                // this.props.appendChatMessage(responseData.data, ID);

            }

            this.scrollToBottom();

        });
        document.getElementById('closeBtn') && document.getElementById('closeBtn').click();
    };

    // If you setState the crop in here you should return false.
    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.jpeg'
            );
            this.setState({croppedImageUrl});
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
                this.setState({blob}) //added by SO huy nguyen
            }, 'image/jpeg');
        });
    }

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({crop});
    };

    /*  Image Crop */
    onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({src: reader.result})
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    handleProfileChange = async (e) => {
        const config = {responseType: 'blob'};
        /*let file = axios.get(this.state.croppedImageUrl, config).then(response => {
            new File([response.data], 'my_image.png', {type: "image/jpg", lastModified: new Date()});
        });*/
        var file = new File([this.state.croppedImageUrl], "my_image.png", {
            type: "image/png",
            lastModified: new Date()
        });
        let formData = new FormData();
        // formData.append('user_id', this.props.user.user_id);
        formData.append('image', this.state.blob);
        this.setState({groupAvatarPreview: this.state.croppedImageUrl, groupAvatar: this.state.blob})
        // formData.append('remove_profile', 0);
        // this.setState({profile_pic: this.state.blob.toString()});
        this.setState({profilePicLoader: true}, document.getElementById('close-profilePictureUpload') && document.getElementById('close-profilePictureUpload').click());
        try {
            await this.props.actionAddUpdateUserProfilePic(formData, this.setProfilePic);
            this.setState({
                profilePicLoader: false,
                src: null,
                blob: ''
            }, () => document.getElementById('profile-pic-selector').value = '');
        }
        catch (error) {
            this.setState({profilePicLoader: false});
            console.error({"error setting profile pic": error});
        }
    };

    setProfilePic = (avatar_preview, image) => {
        this.setState({avatar_preview, avatar: image})
    };

    deleteGroup = () => {
        this.props.DeleteGroup((this.state.selectedAgent && this.state.selectedAgent.type === "Group") && this.state.selectedAgent._id);
        this.setState({selectedAgent: ''})
    };

    onChangechatFilterMember = (e) => this.setState({[e.target.name]: e.target.value});

    onSelectMember = (person) => {
        const isExist = this.state.optionSelected && this.state.optionSelected.find(f => f.value === person._id);
        // console.log({isExist});
        const isExistFilter = isExist && this.state.optionSelected && this.state.optionSelected.filter(f => f.value !== isExist.value);
        // console.log({isExistFilter});
        if (!isExist) {
            this.setState({
                optionSelected: [...this.state.optionSelected, {value: person._id, label: person.name,}]
            })
        } else if (isExistFilter) {
            this.setState({
                optionSelected: isExistFilter
            })
        }

    };

    render() {
        const {groupConversationListing, allProperties, chatLists} = this.props;
        const {errors, crop, src} = this.state;

        let options = [];
        (this.props.agents && this.props.agents.length > 0) && this.props.agents.filter(c => (c._id !== this.props.user._id && c.role.name !== "Admin") && options.push({
            value: c._id,
            label: c.name,
            avatar: c.avatar
        }));
        const listingMember = this.props.agents && this.props.agents.filter(c => c.role.name !== "Admin");
        //console.log({listingMember});

        let optionsMember = !this.state.chatFilterMember ? listingMember : listingMember.filter(a => {
            return a.name && a.name.toLowerCase().indexOf(this.state.chatFilterMember.toLowerCase()) > -1;
        });

        let filteredChatList = !this.state.chatFilter ? chatLists && chatLists : chatLists.filter(a => {
            return a.name && a.name.toLowerCase().indexOf(this.state.chatFilter.toLowerCase()) > -1;
        });


        let filteredShareProperties = !this.state.filter ? allProperties : allProperties.filter(a => {
            return (a.title && a.title.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1) || (a.owner_name && a.owner_name.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1);
        });
        let filteredChatMessage = '';
        if (chatLists && chatLists) {
            const openConversationUser = chatLists.find(chatUser => chatUser._id === this.state.selectedAgent._id);

            // console.log(openConversationUser, 'openConversationUser.conversation');

            if (openConversationUser) {
                if (typeof openConversationUser.conversation !== 'undefined') {
                    filteredChatMessage = !this.state.filterChatMsg ? openConversationUser.conversation : openConversationUser.conversation.filter(a => {
                        return (a.message && a.message.toLowerCase().indexOf(this.state.filterChatMsg.toLowerCase()) > -1);
                    });
                }
            }
        }


        return (
            <Fragment>
                <div className="private-chat-section">
                    <div className="container bg-white py-1">
                        <div className="chat-section bg-white p-3">
                            <div className="row no-gutters">
                                <div className="col-md-4 border-right">
                                    <div className="settings-tray mt-2 mr-2">
                                        <img className="profile-image"
                                             src={this.props.user.avatar ? this.props.user.avatar : image}
                                             alt="Profile img"/>
                                        <span className="settings-tray--right">
                                     {/*<i className="material-icons">cached</i>*/}
                                            {/*<i className="material-icons">message</i>*/}
                                            {/*<i className="material-icons">menu</i>*/}
                                            {
                                                (this.props.user && this.props.user.role.name === "Admin") ?
                                                    <i className="material-icons" id="openBroadcast"
                                                       data-toggle="modal"
                                                       data-tip data-for="AddGroup"
                                                       data-target="#createBroadcastModal"
                                                       data-backdrop="static" data-keyboard="false" onClick={() => {
                                                        this.props.agentListing({q: '', offset: '', limit: ''});
                                                        this.setState({
                                                            modal_name: 'CREATE_GROUP',
                                                            message: '',
                                                            group: '',
                                                            optionSelected: '',
                                                            GroupOwner: '',
                                                            groupId: '',
                                                            selectedAgent: '',
                                                            avatar: '',
                                                            avatar_preview: ''
                                                        })
                                                    }}>group_add</i>
                                                    :
                                                    <i className="material-icons" onClick={() =>
                                                        swal({
                                                            title: "you don't have permission to create group.",
                                                            //text: "Are you sure want to Delete this Group ?",
                                                            icon: "warning",
                                                            buttons: [false, "Ok"],
                                                            dangerMode: true,
                                                        })}>group_add</i>
                                            }
                                            <ReactTooltip id="AddGroup" place="top" effect="solid"
                                                          type="dark">Create Group</ReactTooltip>
		                    </span>
                                    </div>
                                    <div className="search-box">
                                        <div className="input-wrapper">
                                            {/*<SearchIcon />*/}
                                            <i className="material-icons">search</i>
                                            <input placeholder="Search here" name="chatFilter"
                                                   onChange={this.handleChange}
                                                   value={this.state.chatFilter} type="text"/>
                                        </div>
                                    </div>
                                    {/*left side agent listing*/}
                                    <div className="chat-panel">
                                        {filteredChatList
                                            ?
                                            (filteredChatList && filteredChatList.length > 0) ? filteredChatList.map((agent, index) =>
                                                <Fragment key={index}>
                                                    <div className="friend-drawer friend-drawer--onhover"
                                                         onClick={() => this.setChatAgent(agent)}>
                                                        <img className="profile-image"
                                                             src={agent.image ? agent.image : image}
                                                             alt=""/>
                                                        <div className="text">
                                                            {
                                                                agent.type === "Group" ?
                                                                    <h6>{agent.name}<i
                                                                        className="fa fa-users float-right ml-3 text-dark"/>
                                                                    </h6>
                                                                    : <h6>{agent.name}</h6>
                                                            }
                                                            <p className="text-muted last-message">{agent.last_message && agent.last_message !== null ? agent.last_message.message : 'Heyy! type something..'}</p>
                                                        </div>

                                                    </div>
                                                    <div className="text-right w-100">
                                                    <span
                                                        className="time text-muted last-message">{(agent.last_message && agent.last_message !== null) && moment(agent.last_message_time).fromNow()}</span>

                                                        {agent.is_new_massage &&
                                                        <span className="text-danger">new msg</span>}
                                                    </div>

                                                    <hr/>
                                                </Fragment>
                                            ) : <DataNotFound message={'Not Found'}/> :
                                            (chatLists && chatLists.length > 0) ? chatLists.map((agent, index) =>
                                                    <Fragment key={index}>
                                                        <div className="friend-drawer friend-drawer--onhover"
                                                             onClick={() => this.setChatAgent(agent)}>
                                                            <img className="profile-image"
                                                                 src={agent.image ? agent.image : image}
                                                                 alt=""/>
                                                            <div className="text">
                                                                <h6>{agent.name}</h6>
                                                                <p className="text-muted">{agent.last_message && agent.last_message !== null ? agent.last_message.message : 'Heyy! type something..'}</p>
                                                            </div>

                                                        </div>
                                                        <div className="text-right w-100">
                                                    <span
                                                        className="time text-muted small ">{(agent.last_message && agent.last_message !== null) && moment(agent.last_message_time).fromNow()}</span>
                                                        </div>
                                                    </Fragment>
                                                )
                                                : <DataNotFound message={'Not Found'}/>
                                        }
                                    </div>
                                </div>
                                {
                                    this.props.reduxData._id || (this.state.selectedAgent.type === "Agent" && this.state.selectedAgent._id || this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id) ?
                                        <div className="col-md-8 mt-2">
                                            <div className="settings-tray ml-2">
                                                <div
                                                    className="friend-drawer conversation-nav no-gutters friend-drawer--grey">
                                                    <img className="profile-image"
                                                         src={this.props.reduxData.image || (this.state.selectedAgent.type === "Agent" && this.state.selectedAgent.image ? this.state.selectedAgent.image : image || this.state.selectedAgent.type === "Group" && this.state.selectedAgent.image ? this.state.selectedAgent.image : image)}
                                                         alt=""/>
                                                    <div className="text">
                                                        <h6>
                                                            {this.props.reduxData.name || (this.state.selectedAgent.type === "Agent" && this.state.selectedAgent.name ? this.state.selectedAgent.name : 'Hey...' || this.state.selectedAgent.type === "Group" && this.state.selectedAgent.name ? this.state.selectedAgent.name : "Hey!..")}
                                                            <span
                                                                className="badge badge-custom  ml-3">{this.state.GroupAdmin ? this.state.GroupAdmin + ' - (Group Owner)' : ''}</span>
                                                        </h6>
                                                        {
                                                            this.state.selectedAgent.type === "Group" ?
                                                                <p className="text-muted last-message">{this.state.selectedAgent.members.map(m => m._id !== this.props.user._id && `${m.name},`)}</p>
                                                                :
                                                                (this.state.selectedAgent.type === "Agent" && this.state.is_typing === true) ?
                                                                    <p className="text-muted">{'Typing...'}</p>
                                                                    :
                                                                    <p className="text-muted">{this.props.reduxData.is_online === true || this.state.selectedAgent.type === "Agent" && this.state.selectedAgent.is_online === true ? 'Online' : 'Offline'}</p>
                                                        }

                                                    </div>
                                                    <div className="d-flex ml-auto">
                                                        {/*{this.state.selectedAgent.type === "Agent" || this.state.selectedAgent.status === 1 ?*/}
                                                        <div className="search">
                                                            <input type="text" placeholder="search"
                                                                   value={this.state.filterChatMsg}
                                                                   name="filterChatMsg"
                                                                   onChange={this.handleChange}/>
                                                            <div className="symbol">
                                                                {/*<span className="cloud"><i className="fa fa-search"/></span>*/}
                                                                <span className="lens"><i
                                                                    className="fa fa-search"/></span>

                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span className="settings-tray--right mt-2">
                                                                {(this.props.user && this.props.user.role.name !== "User" && (this.state.selectedAgent.type === "Agent" || this.state.selectedAgent.type === "Group" && this.state.selectedAgent.status === 1)) ?
                                                                    <Fragment>
                                                                        <i className="fas fa-plus-square"
                                                                           data-toggle="modal"
                                                                           data-tip data-for="AddProperty"
                                                                           data-target="#createBroadcastModal"
                                                                           data-backdrop="static" data-keyboard="false"
                                                                           onClick={() => this.handleModal("CREATE_POST")}/>
                                                                        <ReactTooltip id="AddProperty" place="top"
                                                                                      effect="solid"
                                                                                      type="dark">Share Property In
                                                                            Chat</ReactTooltip>
                                                                    </Fragment>
                                                                    :
                                                                    <Fragment>
                                                                        <i className="fas fa-plus-square"
                                                                           data-tip data-for="AddProperty"/>
                                                                        <ReactTooltip id="AddProperty" place="top"
                                                                                      effect="solid"
                                                                                      type="dark">You can not allowed
                                                                            share property</ReactTooltip>
                                                                    </Fragment>
                                                                }
                                                                {
                                                                    this.state.selectedAgent.type === "Group" &&
                                                                    <ButtonDropdown
                                                                        isOpen={this.state.isOpen}
                                                                        toggle={() => {
                                                                            this.setState({isOpen: !this.state.isOpen});
                                                                        }}
                                                                        className="bg-transparent border-0"
                                                                    >
                                                                        <DropdownToggle
                                                                            className="bg-transparent border-0">
                                                                            <i className="fa fa-ellipsis-v fa-lg ml-5 text-dark"
                                                                               onClick={() => this.handleModal("CREATE_GROUP")}/>
                                                                        </DropdownToggle>
                                                                        {
                                                                            this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id &&
                                                                            (this.state.selectedAgent && this.state.selectedAgent.admins.find(f => f._id === this.props.user._id) || this.state.LoggedInUsesIsOwner || this.props.user.role.name === "Admin" ?
                                                                                    <DropdownMenu>
                                                                                        {
                                                                                            this.state.selectedAgent.status === 1 &&
                                                                                            <DropdownItem
                                                                                                id="openBroadcast"
                                                                                                data-toggle="modal"
                                                                                                data-target="#createBroadcastModal"
                                                                                                onClick={() => this.setState({modal_name: 'CREATE_GROUP'}, () => this.props.agentListing({
                                                                                                    q: '',
                                                                                                    offset: '',
                                                                                                    limit: ''
                                                                                                }))}>Update </DropdownItem>
                                                                                        }

                                                                                        {
                                                                                            this.props.user.role.name === "Admin"
                                                                                                ?
                                                                                                <DropdownItem
                                                                                                    onClick={() => {
                                                                                                        this.state.selectedAgent.status === 1 ?
                                                                                                            swal({
                                                                                                                title: "Are you sure?",
                                                                                                                text: "Are you sure want to Deactivate this Group ?",
                                                                                                                icon: "warning",
                                                                                                                buttons: true,
                                                                                                                dangerMode: true,
                                                                                                            })
                                                                                                                .then((willDelete) => {
                                                                                                                    if (willDelete) {
                                                                                                                        this.onInactiveGroup();
                                                                                                                        swal("Poof! You Deactivate this group..!", {
                                                                                                                            icon: "success",
                                                                                                                        });

                                                                                                                    } else {
                                                                                                                        swal("Your group is safe..!");
                                                                                                                    }
                                                                                                                }) :
                                                                                                            swal({
                                                                                                                title: "For Active Group Contact to Admin",
                                                                                                                text: "please mail us on :- primeprivatenetwork@gmail.com",
                                                                                                                icon: "warning",
                                                                                                                buttons: true,
                                                                                                                dangerMode: true,
                                                                                                            })

                                                                                                    }
                                                                                                    }>{this.state.selectedAgent.status === 1 ? 'Deactivate' : 'Active'}</DropdownItem>
                                                                                                :
                                                                                                <DropdownItem
                                                                                                    onClick={() => {
                                                                                                        this.state.selectedAgent.status === 1 ?
                                                                                                            swal({
                                                                                                                title: "You can't Deactivate this group",
                                                                                                                //text: "Are you sure want to Delete this Group ?",
                                                                                                                icon: "warning",
                                                                                                                buttons: true,
                                                                                                                dangerMode: true,
                                                                                                            }) :
                                                                                                            swal({
                                                                                                                title: "For Active Group Contact to Admin",
                                                                                                                text: "please mail us on :- primeprivatenetwork@gmail.com",
                                                                                                                icon: "warning",
                                                                                                                buttons: true,
                                                                                                                dangerMode: true,
                                                                                                            })
                                                                                                    }
                                                                                                    }>{this.state.selectedAgent.status === 1 ? 'Deactivate' : 'Active'}</DropdownItem>
                                                                                        }
                                                                                    </DropdownMenu>
                                                                                    :
                                                                                    <DropdownMenu>
                                                                                        <DropdownItem onClick={() =>
                                                                                            swal({
                                                                                                title: "Are you sure?",
                                                                                                text: "Are you sure want to Exit this Group?",
                                                                                                icon: "warning",
                                                                                                buttons: true,
                                                                                                dangerMode: true,
                                                                                            })
                                                                                                .then((willDelete) => {
                                                                                                    if (willDelete) {
                                                                                                        this.props.exitFromGroup(this.state.selectedAgent._id, this.props.user._id, this.setState({selectedAgent: ''}));
                                                                                                        swal("Poof! You Exit this group..!", {
                                                                                                            icon: "success",
                                                                                                        });

                                                                                                    }
                                                                                                })}>Exit</DropdownItem>
                                                                                    </DropdownMenu>
                                                                            )}
                                                                    </ButtonDropdown>
                                                                }
                                                                {/*<i className="material-icons">cached</i>*/}
                                                                {/*<i className="material-icons">message</i>*/}
                                                                {/*<i className="material-icons">menu</i>*/}
			                                </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="chat-panel" id='chat-msg-container'>
                                                {filteredChatMessage && filteredChatMessage.length > 0 && filteredChatMessage.map((msg, index) => msg.message ?
                                                    <MessageItem message={msg.message}
                                                                 name={msg.receiver.length > 1 && (msg.user && msg.user.name)}
                                                                 time={msg.createdAt}
                                                                 isSender={msg.user._id === (this.props.user && this.props.user._id)}
                                                                 key={index}/>
                                                    :

                                                    <SendPropertyChatCard
                                                        isSender={msg.user._id === this.props.user._id}
                                                        image={msg.properties.image ? msg.properties.image : defaultAvatar}
                                                        id={msg.properties._id}
                                                        title={msg.properties.title}
                                                        price={msg.properties.price}
                                                        time={msg.createdAt}
                                                        name={msg.receiver.length > 1 && msg.user.name}
                                                    />)}
                                            </div>
                                            <div className="row ml-2">
                                                <div className="col-12">
                                                    <form onSubmit={this.onSendMessageSubmit}>
                                                        <div className="chat-box-tray">
                                                            {/* <i className="material-icons">group_add</i>*/}
                                                            <input
                                                                className="ml-4"
                                                                type="text"
                                                                value={this.state.message}
                                                                name="message"
                                                                placeholder="Type your message here..."
                                                                autoComplete={'off'}
                                                                onKeyUp={this.handleKeyUp}
                                                                onChange={this.handleChange}
                                                                disabled={this.state.selectedAgent.type === "Agent" || this.state.selectedAgent.status === 1 ? '' : 'disabled'}
                                                            />
                                                            {/*<i className="material-icons">mic</i>*/}
                                                            <button
                                                                className="border-0 p-0 m-0 cursor-pointer msg-send-btn">
                                                                <i className="fad fa-paper-plane"/>
                                                            </button>
                                                            {/*<button className="border-0 p-0 m-0"><i*/}
                                                            {/*className="fad fa-share-square"/>*/}
                                                            {/*</button>*/}
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="text-center col-md-8"><DefaultChat
                                            message={`Please Select Agent or Group For Conversation.`}/></div>

                                }
                            </div>
                        </div>
                    </div>
                    <Fragment>
                        {/* Create Broadcast Modal */}
                        <div className="modal fade" id="createBroadcastModal" tabIndex={-1} role="dialog"
                             aria-labelledby="createBroadcastModalLabel" aria-hidden="true" style={{marginTop: "2em"}}>
                            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">

                                <div className="modal-content" style={{zIndex: '9999999999999999 !important'}}>
                                    <div className="modal-header">
                                        {this.state.modal_name === 'CREATE_GROUP' &&
                                        <h5 className="modal-title w-100 text-center"
                                            id="createBroadcastModalLabel">{this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id ? "Update Group" : 'Create Group'}</h5>}
                                        {this.state.modal_name === 'CREATE_POST' &&
                                        <h5 className="modal-title w-1100 text-center"
                                            id="createBroadcastModalLabel">Create Post</h5>}


                                        <button type="button" id="closeBtn" className="close" data-dismiss="modal"
                                                aria-label="Close">
                                            <span aria-hidden="true h3">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        {/*{*/}
                                        {/*this.state.GroupAdmin &&*/}
                                        {/*<p className="ml-3">*/}
                                        {/*<span className="badge badge-custom">*/}
                                        {/*<i className="fa fa-user-lock mr-2"/>*/}
                                        {/*{this.state.GroupAdmin ? this.state.GroupAdmin + '(Group Admin)' : ' '}*/}
                                        {/*</span>*/}
                                        {/*</p>*/}
                                        {/*}*/}
                                        {this.state.modal_name === 'CREATE_GROUP' &&
                                        <Form className='auth-forgot-password-form mt-2' autoComplete="off"
                                              noValidate={true}
                                              onSubmit={this.onCreateGroupSubmit}>
                                            <FormGroup className="p-3">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <Label className='form-label' for='login-email'>
                                                            Group Name
                                                        </Label>
                                                        <Input type='text' className="mx-auto row w-100 p-2"
                                                               value={this.state.group}
                                                               name="group" onChange={this.handleChange}
                                                               placeholder="Enter Group Name"/>
                                                        {errors.group &&
                                                        <span className='text-danger'>{errors.group}</span>}
                                                    </div>
                                                    <div className="col-lg-6">
                                                        {
                                                            this.props.user && this.props.user.role.name === "Admin" ?
                                                                <div className="">
                                                                    <Label className='form-label' for='login-email'>
                                                                        Group Owner
                                                                    </Label>
                                                                    <Select
                                                                        name="group-owner"
                                                                        placeholder={this.props.agentsLoader ? "loading.." : "Select Group Owner"}
                                                                        value={this.state.GroupOwner}
                                                                        options={options}
                                                                        onChange={this.handleChangeCheckboxGroupOwner}
                                                                        allowSelectAll={true}
                                                                        isDisabled={!!this.props.agentsLoader}
                                                                    />
                                                                </div>
                                                                :
                                                                <div className="">
                                                                    <Label className='form-label' for='login-email'>
                                                                        Group Owner
                                                                    </Label>
                                                                    <Select
                                                                        name="group-owner"
                                                                        placeholder={this.props.agentsLoader ? "loading.." : "Select Group Owner"}
                                                                        value={this.state.GroupOwner}
                                                                        allowSelectAll={true}
                                                                        isDisabled={true}
                                                                    />
                                                                </div>
                                                        }
                                                        {errors.GroupOwner &&
                                                        <span className='text-danger'>{errors.GroupOwner}</span>}
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="">
                                                            <Label className='form-label' for='login-email'>
                                                                Group Admin
                                                            </Label>
                                                            <Select
                                                                name="group-admin"
                                                                placeholder={this.props.agentsLoader ? "loading.." : "Select Group Admin"}
                                                                value={this.state.admins}
                                                                options={options}
                                                                onChange={this.handleChangeCheckbox}
                                                                allowSelectAll={true}
                                                                isDisabled={!!this.props.agentsLoader}
                                                                isMulti
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <Label className='form-label' for='login-email'>
                                                            Group Member
                                                        </Label>
                                                        <p id="openBroadcast" data-toggle="modal"
                                                           data-target="#createMembersModal"
                                                           data-backdrop="static" data-keyboard="false"
                                                           className="w-100 btn btn-secondary"><i
                                                            className="fa fa-plus-circle mr-2 expand-button-responsive"
                                                            aria-hidden="true"
                                                            title={'Manage Group Member'}/>
                                                            <span>Manage Group Member</span></p>
                                                        {errors.optionSelected &&
                                                        <span className='text-danger'>{errors.optionSelected}</span>}
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="text-center cropper-image mt-3">
                                                            <img
                                                                src={this.state.avatar_preview ? this.state.avatar_preview : image}
                                                                alt="img"/>
                                                            {this.state.profilePicLoader ?
                                                                <div className="add-media">
                                                                    <i className="fa fa-spinner fa-pulse"
                                                                       style={{
                                                                           color: '#fda94f',
                                                                           boxShadow: 'none',
                                                                           fontSize: 25
                                                                       }}/>
                                                                </div> :
                                                                <div className="add-media" data-toggle="modal"
                                                                     data-target="#profilePictureUpload">
                                                                    <i className="fa fa-pencil"/>
                                                                </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="submit"
                                                        className="btn btn-secondary mt-3">{this.state.selectedAgent.type === "Group" && this.state.selectedAgent._id ? 'Update Group' : 'Create Group'}
                                                </button>
                                            </FormGroup>
                                        </Form>}

                                        {this.state.modal_name === 'CREATE_POST' &&
                                        <Fragment>
                                            <div className="col-12">

                                                <label className="sr-only"
                                                       htmlFor="inlineFormInputGroupUsername">Username</label>
                                                <div className="input-group">

                                                    <input type="text" className="form-control"
                                                           value={this.state.filter}
                                                           name="filter" onChange={this.handleChange}
                                                           placeholder="Search Properties"/>
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text"><i className="fal fa-search"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="properties-list-container scrollbar">
                                                {(!this.props.getAllPropertiesLoader && filteredShareProperties && filteredShareProperties.length > 0) ? filteredShareProperties.map((data, index) =>
                                                        <div
                                                            className="d-flex  align-items-center justify-content-between profile-share-card "
                                                            key={index}>
                                                            <div className="d-flex align-items-center">
                                                                <div className="property-img mr-2">
                                                                    <img src={data.image ? data.image : defaultAvatar}
                                                                         alt="Avatar"/>
                                                                </div>
                                                                <div className="ml-2">
                                                                    <h6 className="text-left m-0 ">{data.title}</h6>
                                                                    <p className="m-0">{data.owner_name}</p>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <button className="btn btn-success"
                                                                        onClick={() => this.handleSendProperty(data)}>
                                                                    {this.state.properties.find(d => d === data._id) ? 'ReSend' : 'Send'}<i
                                                                    className="fal fa-paper-plane ml-1"/></button>
                                                            </div>
                                                        </div>
                                                    ) :

                                                    // (this.props.getAllPropertiesLoader && <h6>Loading.....</h6>)
                                                    (this.props.getAllPropertiesLoader && filteredShareProperties.length < 1 ?
                                                        <h6>Loading.....</h6> : <DataNotFound
                                                            message={`No Data Found`}
                                                            img={notFoundImg}
                                                            button={true}
                                                            link={'/add-property'}
                                                            btnName={'Add Property'}
                                                        />)
                                                }

                                            </div>
                                        </Fragment>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Fragment>
                    <Fragment>
                        {/* Create Member Modal */}
                        <div className="modal fade" id="createMembersModal" tabIndex={-1} role="dialog"
                             aria-labelledby="createMembersModalLabel" aria-hidden="true" style={{marginTop: "2em"}}>
                            <div className="modal-dialog modal-dialog-centered" role="document">

                                <div className="modal-content" style={{zIndex: '9999999999999999 !important'}}>
                                    <form autoComplete="off" noValidate={true}>
                                        <div className="modal-header bg-light">
                                            <h5 className="modal-title w-100 text-center"
                                                id="createMembersModalLabel">Group Member</h5>
                                            <button type="button" id="closeBtn" className="close" data-dismiss="modal"
                                                    aria-label="Close">
                                                <span aria-hidden="true h3">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body pt-0">

                                            <div className="mt-3">
                                                <div className="input-group mb-4">
                                                    <input type="text" className="form-control"
                                                           placeholder="Search Member" name="chatFilterMember"
                                                           onChange={this.onChangechatFilterMember}
                                                           value={this.state.chatFilterMember}/>
                                                    <div className="input-group-append">
                                                        <button className="btn btn-secondary" type="button">
                                                            <i className="fa fa-search"/>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-flex align-items-center justify-content-between pl-2 pr-2">
                                                    {this.state.optionSelected && this.state.optionSelected.length > 0 &&
                                                    <span
                                                        className="ml-2 person-selected">{this.state.optionSelected.length} Person
                                                        Selected.
                                                    <span className="broadcast-next-btn" type="button" id="closeBtn"
                                                          data-dismiss="modal"
                                                          aria-label="Close"><i
                                                        className="fa fa-arrow-right"/>
                                                        </span></span>}
                                                    {this.props.agentsLoader &&
                                                    <div className="broadcast-next-btn">Loading...</div>}
                                                </div>
                                                <div id="contacts" className="broadcast-model-contact">
                                                    <ul style={{height: 250, overflowX: 'hidden'}}>
                                                        {/*{!filteredBroadcastPersonList.length >0&&*/}
                                                        {/*<div className="text-center mt-5"><Spinner width={100}/></div>*/}
                                                        {/*}*/}

                                                        {(optionsMember && !optionsMember.length) &&
                                                        <div className="w-50 mx-auto">
                                                            <DataNotFound message={'Not Found'}/>
                                                        </div>
                                                        }

                                                        {(optionsMember && optionsMember.length > 0) && optionsMember.map((person, index) =>
                                                            <li key={index}
                                                                className={`${this.state.optionSelected && this.state.optionSelected.find(f => f.value === person._id) || this.state.GroupOwner && this.state.GroupOwner.value === person._id ? 'contact active-mem' : 'contact'}`}
                                                                onClick={() =>
                                                                    this.state.GroupOwner && this.state.GroupOwner.value === person._id ?
                                                                        ''
                                                                        : this.onSelectMember(person)
                                                                }>
                                                                <div
                                                                    className={`${this.state.GroupOwner && this.state.GroupOwner.value === person._id && 'not-allowed'} wrap`}>
                                                                    <div className="row">
                                                                        <div className="col-3 broad-chat-user-img">
                                                                            <img
                                                                                src={person.avatar}
                                                                                alt=""/>
                                                                        </div>
                                                                        <div
                                                                            className="col-9 broad-chat-recent-msg my-auto">
                                                                            <div className="meta">
                                                                                <p className="name text-dark">{person.name}{this.state.GroupOwner && this.state.GroupOwner.value === person._id &&
                                                                                <span> <i
                                                                                    className="fa fa-user-lock ml-2"/> - Group Owner</span>}</p>

                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </li>)}

                                                    </ul>
                                                </div>
                                                {/*<Select*/}
                                                {/*name="agents"*/}
                                                {/*placeholder={this.props.agentsLoader ? "loading.." : "Select Group Member"}*/}
                                                {/*value={this.state.optionSelected}*/}
                                                {/*options={options}*/}
                                                {/*onChange={this.handleChangeCheckbox}*/}
                                                {/*allowSelectAll={true}*/}
                                                {/*isDisabled={!!this.props.agentsLoader}*/}
                                                {/*isMulti*/}
                                                {/*/>*/}
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>

                    </Fragment>
                    <Fragment>
                        <div className="modal fade" id="profilePictureUpload" role="dialog" data-backdrop="static"
                             data-keyboard="false"
                             aria-labelledby="profilePictureUploadTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLongTitle">Change Group
                                            Picture</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body text-center ">
                                        <div className="row">
                                            <div className="col-12 text-center ">
                                                {src ? (
                                                    <ReactCrop
                                                        src={src}
                                                        crop={crop}
                                                        ruleOfThirds
                                                        onImageLoaded={this.onImageLoaded}
                                                        onComplete={this.onCropComplete}
                                                        onChange={this.onCropChange}
                                                        className={'profile-preview-image'}
                                                    />
                                                ) : <img width={250}
                                                         src={this.state.avatar_preview ? this.state.avatar_preview : image}
                                                         alt="Profile Picture"/>}
                                            </div>
                                        </div>
                                        <hr/>
                                        <input id={'profile-pic-selector'} type="file" accept="image/*"
                                               onChange={this.onSelectFile}/>

                                    </div>
                                    <div className="modal-footer">
                                        <button id={'close-profilePictureUpload'} type="button"
                                                className="btn btn-danger" data-dismiss="modal">Close
                                        </button>
                                        <button className="btn btn-success" onClick={this.handleProfileChange}>Save
                                            changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        reduxData: state.profile.reduxData,
        user: state.auth.user,
        agents: state.profile.agents,
        agentsLoader: state.profile.agentsLoader,
        chatLists: state.profile.chatLists,
        chatListsLoader: state.profile.chatListsLoader,
        groupConversationListingLoader: state.profile.groupConversationListingLoader,
        groupConversationListing: state.profile.groupConversationListing,
        getAllPropertiesLoader: state.property.getAllPropertiesLoader,
        isNextAPICall: state.profile.isNextAPICall,
        allProperties: state.property.allProperties,
    }
};

export default connect(mapStateToProps, {
    getGroupConversation,
    appendChatMessage,
    changeGroupName,
    createGroup,
    setDataInRedux,
    UpdateGroup,
    removeDataInRedux,
    actionGetAllPropertyList,
    actionAddUpdateUserProfilePic,
    setOnlineInRedux,
    getChatList,
    DeleteGroup,
    exitFromGroup,
    agentListing,
    appendReceiveChatMessage,
    appendLastChatMessage
})(SingleAgentList);
